"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_react_1 = require("mobx-react");
var Grid_styles_1 = require("./Grid.styles");
var Grid_classNames_1 = require("./Grid.classNames");
var Grid = /** @class */ (function (_super) {
    __extends(Grid, _super);
    function Grid() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onRootScroll = function () {
            var grid = _this.props.grid;
            grid.position(0 - _this._rootRef.scrollLeft, 0 - _this._rootRef.scrollTop);
        };
        _this._onRootRef = function (ref) {
            _this._rootRef = ref;
        };
        _this._onRowContainerRef = function (ref) {
            _this._rowContainerRef = ref;
        };
        return _this;
    }
    Grid.prototype._renderCell = function (row, column) {
        return (React.createElement("div", { key: column, className: this._classNames.cell, style: {
                minWidth: this.props.grid.cellSize,
                width: this.props.grid.cellSize,
                minHeight: this.props.grid.cellSize,
                height: this.props.grid.cellSize,
                marginLeft: this.props.grid.cellMargin
            } }));
    };
    Grid.prototype._renderRow = function (row) {
        var cells = [];
        for (var i = 0; i < this.props.grid.columns; i++) {
            cells.push(this._renderCell(row, i));
        }
        return (React.createElement("div", { className: this._classNames.row, key: row, style: { marginTop: this.props.grid.cellMargin } }, cells));
    };
    /*
    private _renderWindow(w : IWindow) : React.ReactNode {
        return <Window key={w.id} relative window={w} />;
    }
    */
    Grid.prototype.render = function () {
        var _a = this.props, grid = _a.grid, styles = _a.styles;
        this._classNames = Grid_classNames_1.getClassNames(Grid_styles_1.getStyles(null, styles));
        var rows = [];
        for (var r = 0; r < grid.rows; r++) {
            rows.push(this._renderRow(r));
        }
        /*
        const windows = grid.windows.map(w => {
            return this._renderWindow(w);
        });
        */
        return (React.createElement("div", { className: this._classNames.root, ref: this._onRootRef, onScroll: this._onRootScroll },
            React.createElement("div", { className: this._classNames.rowContainer, ref: this._onRowContainerRef }, rows)));
    };
    Grid = __decorate([
        mobx_react_1.observer
    ], Grid);
    return Grid;
}(React.Component));
exports.Grid = Grid;
